import React, { useState, useEffect, useMemo } from 'react';
import { Button, Badge, Modal, Form, Spinner, Row, Col } from 'react-bootstrap';
import api from '../../services/api';
import {
    FaPlus, FaEdit, FaTrash, FaMailBulk, FaWhatsapp,
    FaMobileAlt, FaCode, FaBell, FaInfoCircle
} from 'react-icons/fa';
import ReusableAdminTable from './ReusableAdminTable';
import './NotificationTemplates.css';
import { Controller } from 'react-hook-form';

import RichTextEditor from '../../components/common/RichTextEditor';


// const NotificationTemplates = () => {
    // const NotificationTemplates = ({ control}) => (
        const NotificationTemplates = ({ control }) => {
    

    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState({
        tmp_name: '', tmp_type: 'email', tmp_subject: '', tmp_text: '', is_active: true
    });

    // 🔥 FETCH
    const fetchTemplates = async () => {
        setLoading(true);
        try {
            const res = await api.get('/admin/templates');
            setTemplates(res.data.data || []);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    useEffect(() => { fetchTemplates(); }, []);

    const handleSave = async () => {
        try {
            await api.post('/admin/templates/save', formData);
            setShowModal(false);
            fetchTemplates();
        } catch (err) { alert("Save failed"); }
    };

    // ICON
    const getChannelIcon = (type) => {
        switch (type) {
            case 'email': return <FaMailBulk className="text-primary" />;
            case 'whatsapp': return <FaWhatsapp className="text-success" />;
            case 'sms': return <FaMobileAlt className="text-warning" />;
            case 'push': return <FaBell className="text-info" />;
            default: return <FaInfoCircle />;
        }
    };

    // 🔥 TABLE COLUMNS
    const columns = useMemo(() => [
        {
            header: "Channel",
            cell: (info) => {
                const t = info.row.original;
                return (
                    <div className="d-flex align-items-center gap-2">
                        {getChannelIcon(t.tmp_type)}
                        <span className="badge-channel text-uppercase">
                            {t.tmp_type || 'email'}
                        </span>
                    </div>
                );
            }
        },
        {
            accessorKey: "tmp_name",
            header: "Template Identity"
        },
        {
            header: "Subject / Preview",
            cell: (info) => {
                const t = info.row.original;
                return (
                    <div className="subject-preview">
                        {t.tmp_subject || t.tmp_text?.substring(0, 40) + '...'}
                    </div>
                );
            }
        },
        {
            header: "Status",
            cell: (info) => {
                const t = info.row.original;
                return (
                    <Badge
                        bg={t.is_active ? 'success' : 'secondary'}
                        className="rounded-pill px-3"
                        style={{ fontSize: '9px' }}
                    >
                        {t.is_active ? 'ACTIVE' : 'DISABLED'}
                    </Badge>
                );
            }
        },
                {
            id: "manage",
            header: () => <div style={{ textAlign: "center", width: "100%" }}>MANAGE</div>,
            cell: (info) => {
                const t = info.row.original;
                return (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", width: "100%", margin: "0 auto" }}>
                        {/* ✅ EDIT BUTTON: BLUE */}
                        <button
                            type="button"
                            style={{
                                background: "#2563eb",
                                backgroundColor: "#2563eb",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "6px",
                                width: "32px",
                                height: "32px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                padding: 0,
                                flexShrink: 0
                            }}
                            onClick={() => {
                                setFormData(t);
                                setShowModal(true);
                            }}
                            title="Edit Template"
                        >
                            <FaEdit size={14} color="#ffffff" />
                        </button>

                        {/* ✅ DELETE BUTTON: RED */}
                        <button
                            type="button"
                            style={{
                                background: "#dc2626",
                                backgroundColor: "#dc2626",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "6px",
                                width: "32px",
                                height: "32px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                padding: 0,
                                flexShrink: 0
                            }}
                            onClick={async () => {
                                if (window.confirm('Delete?')) {
                                    await api.delete(`/admin/templates/${t.id}`);
                                    fetchTemplates();
                                }
                            }}
                            title="Delete Template"
                        >
                            <FaTrash size={14} color="#ffffff" />
                        </button>
                    </div>
                );
            }
        }
    ], []);

    // TAGS
    const dynamicTags = [
        { tag: '%NAME%', label: 'User Name' },
        { tag: '%EMAIL%', label: 'User Email' },
        { tag: '%MOBILE%', label: 'Mobile No' },
        { tag: '%OTP%', label: 'One Time Pass' },
        { tag: '%PASSWORD%', label: 'Clear Password' },
        { tag: '%ROLE%', label: 'Role Title' },
        { tag: '%PROJECT%', label: 'Project Name' },
        { tag: '%CATEGORY%', label: 'Role Category' },
        { tag: '%PROJECT_TYPE%', label: 'Film/Web/TV' },
        { tag: '%LOCATION%', label: 'Venue' },
        { tag: '%DATE_TIME%', label: 'Slot Timing' },
        { tag: '%HEIGHT%', label: 'Height Req.' },
        { tag: '%WEIGHT%', label: 'Weight Req.' },
        { tag: '%RESULT%', label: 'Decision Status' },
        { tag: '%REVIEW_COMMENT%', label: 'Director Feedback' },
        { tag: '%LOGIN_URL%', label: 'Login Link' }
    ];

    return (
        <div className="admin-notification-page animate-fade-in">
            {/* 🔥 REUSABLE TABLE */}
            <ReusableAdminTable
                data={templates}
                columns={columns}
                isLoading={loading}
                title="Notification Templates"
                

                onAddNew={() => {
                    setFormData({
                        tmp_name: '',
                        tmp_type: 'email',
                        tmp_subject: '',
                        tmp_text: '',
                        is_active: true
                    });
                    setShowModal(true);
                }}

                addNewButtonText="Create Template"
            />

            {/* MODAL (UNCHANGED) */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
                centered
                className="dark-modal custom-modal-ui"
            >
                <Modal.Header closeButton closeVariant="white">
                    <Modal.Title className="notification-title">
                        {formData.id ? 'Refine' : 'Add'} Notification Template
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-0">
                    <Row className="g-0">

                        <Col lg={8} className="p-4 border-end border-secondary">
                            <Row className="g-3">

                                <Col md={6}>
                                    <Form.Label className="label-custom">CHANNEL TYPE</Form.Label>
                                    <Form.Select
                                        className="input-dark"
                                        value={formData.tmp_type || 'email'}
                                        onChange={e => setFormData({ ...formData, tmp_type: e.target.value })}
                                    >
                                        <option value="email">📧 Email Gateway</option>
                                        <option value="sms">📱 SMS Gateway</option>
                                        <option value="whatsapp">💬 WhatsApp Business</option>
                                        <option value="push">🔔 Push Notification</option>
                                    </Form.Select>
                                </Col>

                                <Col md={6}>
                                    <Form.Label className="label-custom">TEMPLATE SLUG</Form.Label>
                                    <Form.Control
                                        className="input-dark"
                                        value={formData.tmp_name ?? ''}
                                        onChange={e => setFormData({ ...formData, tmp_name: e.target.value })}
                                    />
                                </Col>

                            </Row>

                            <div className="mt-4">
                                <Form.Label className="label-custom">SUBJECT LINE</Form.Label>
                                <Form.Control
                                    className="input-dark"
                                    value={formData.tmp_subject ?? ''}
                                    onChange={e => setFormData({ ...formData, tmp_subject: e.target.value })}
                                />
                            </div>

                            <div className="mt-4">
                                <Form.Label className="label-custom">BODY CONTENT</Form.Label>
                                <RichTextEditor
                                    value={formData.tmp_text ?? ''}
                                    onChange={(val) =>
                                        setFormData({ ...formData, tmp_text: val })
                                    }
                                    />
                            </div>
                        </Col>

                        <Col lg={4} className="p-4 right-panel">

                            <h6 className="tag-heading">
                                <FaCode className="me-2" /> DYNAMIC TAGS
                            </h6>

                            <p className="tag-desc">Click a tag to insert into message.</p>

                            <div className="variable-grid">
                                {dynamicTags.map(item => (
                                    <div
                                        key={item.tag}
                                        className="variable-tag tag-light"
                                        onClick={() =>
                                            setFormData({
                                                ...formData,
                                                tmp_text: formData.tmp_text + ' ' + item.tag
                                            })
                                        }
                                    >
                                        <div className="tag-title">{item.tag}</div>
                                        <div className="tag-sub">{item.label}</div>
                                    </div>
                                ))}
                            </div>

                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer className="footer-custom">
                    <Button variant="link" className="btn-discard" onClick={() => setShowModal(false)}>
                        Discard
                    </Button>
                    <Button className="btn-add-main-notification" onClick={handleSave}>
                        SAVE CONFIGURATION
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
        }

export default NotificationTemplates;